<template>
  <v-list-item-group :value="value" active-class="gray--text" @change="select">
    <v-list-item
      v-for="item in list"
      :key="item.value"
      :value="item.value"
      two-line
    >
      <v-list-item-content>
        <v-list-item-title class="font-weight-bold">
          {{ item.name }}
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ $t('ORDERS.LIST.ITEM_DESCRIPTION_PREFIX') }}
          <strong>{{ item.description }}</strong>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list-item-group>
</template>

<script>
import { BUSINESS, INTERNAL, REPETITIVE_BUSINESS } from './../common/order-types';

export default {
  name: 'CreateBusinessOrderActionList',

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    value: {
      type: Number,
      default: BUSINESS,
      validator: prop => [BUSINESS, INTERNAL, REPETITIVE_BUSINESS].includes(prop)
    }
  },

  computed: {
    list() {
      return [
        {
          name: this.$t('ORDERS.ITEM'),
          description: this.$t('ORDERS.LIST.ITEMS.ORDER'),
          value: BUSINESS
        },
        {
          name: this.$t('ORDERS.INTERNAL_ORDER'),
          description: this.$t('ORDERS.LIST.ITEMS.INTERNAL_ORDER'),
          value: INTERNAL
        },
        {
          name: this.$t('ORDERS.REPETITIVE.ITEM'),
          description: this.$t('ORDERS.LIST.ITEMS.REPETITIVE'),
          value: REPETITIVE_BUSINESS
        }
      ];
    }
  },

  created() {
    this.select(this.value);
  },

  methods: {
    select(value) {
      this.$emit('change', value);
    }
  }
};
</script>
